<template>
    <MainContentTabs
        :tabs="[
            {tab : 'opciones', nombre: 'Activar / Desactivar opciones'},
            {tab : 'imagenes-web', nombre: 'Cambiar imágenes web'},
            {tab : 'imagenes-entrada', nombre: 'Cambiar imágenes entrada'},
            {tab : 'abonos', nombre: 'Abonos'},
            {tab : 'imagenes-base', nombre: 'Cambiar imágenes de deportista'},
            {tab : 'patrocinadores', nombre: 'Patrocinadores'},
            {tab : 'tipo-entrada', nombre: 'Tipo de entrada'},
            {tab : 'deportistas', nombre: 'Deportistas'},
            {tab : 'Metodos-pago', nombre: 'Métodos de pago'},
            ...(isManager ? [{tab : 'api-crm', nombre: 'Api crm'}] : [])
        ]"
        initialTab="opciones"
        title="Configuración"
    >
        <template slot="opciones">
            <Opciones :manager="manager" @guardar="guardarOpciones"></Opciones>
        </template>
        <template slot="imagenes-web">
            <ImagenesWeb :manager="manager" @guardar="guardarOpciones"></ImagenesWeb>
        </template>
        <template slot="imagenes-entrada">
            <ImagenesEntrada :manager="manager" @guardar="guardarOpciones"></ImagenesEntrada>
        </template>
        <template slot="abonos">
            <Abonos :manager="manager" @guardar="guardarOpciones"></Abonos>
        </template>
        <template slot="imagenes-base">
            <ImagenesBase :manager="manager" @guardar="guardarOpciones"></ImagenesBase>
        </template>
        <template slot="patrocinadores">
            <Patrocinadores></Patrocinadores>
        </template>
        <template slot="tipo-entrada">
            <TipoEntrada :manager="manager" @guardar="guardarOpciones"></TipoEntrada>
        </template>
        <template slot="deportistas">
            <Bases :manager="manager" @guardar="guardarOpciones"></Bases>
        </template>
        <template slot="Metodos-pago">
            <MetodosPago/>
        </template>
        <template slot="api-crm" v-if="isManager">
            <ApiCrm/>
        </template>
    </MainContentTabs>
</template>

<script>
import MainContentTabs from '@/components/backend/components/MainContentTabs';
import Opciones from './Opciones';
import ImagenesWeb from './ImagenesWeb';
import ImagenesEntrada from './ImagenesEntrada';
import Patrocinadores from './Patrocinadores';
import TipoEntrada from './TipoEntrada.vue'
import Bases from './Bases.vue';
import ApiCrm from './ApiCrm.vue';
import Abonos from './Abonos.vue';
import ImagenesBase from './ImagenesBase.vue';
import MetodosPago from './MetodosPago.vue';

export default {
    computed: {
        manager() {
            return this.$store.getters.getFooter;
        },
        isManager() {
            return this.$store.getters.getUser.id === this.$store.getters.getFooter.user_id;
        }
    },
    methods: {
        guardarOpciones() {
            const params = {
                filters : {},
                lista_id: this.$store.getters.getListaId,
                nuevo_abono: this.manager.nuevo_abono,
                renovar_abono: this.manager.renovar_abono,
                partidos: this.manager.partidos,
                venta_simpatizantes: this.manager.venta_simpatizantes,
                futbol_base: this.manager.futbol_base,
                bg1: this.manager.bg1,
                bg2: this.manager.bg2,
                bg3: this.manager.bg3,
                bg4: this.manager.bg4,
                bg5: this.manager.bg5,
                imagen_patrocinadores: this.manager.imagen_patrocinadores,
                imagen_cabecera: this.manager.imagen_cabecera,
                imagen_publicidad: this.manager.imagen_publicidad,
                imagen_info_bases: this.manager.imagen_info_bases,
                informacion_base: this.manager.informacion_base,
                activar_compra_por_invitacion_bases: this.manager.activar_compra_por_invitacion_bases,
                tipo_entrada: this.manager.tipo_entrada,
                termino_entrada: this.manager.termino_entrada,
                termino_entradas: this.manager.termino_entradas,
                ocultar_iva_entradas: this.manager.ocultar_iva_entradas,
                ocultar_abonos: this.manager.ocultar_abonos,
                ocultar_simpatizantes: this.manager.ocultar_simpatizantes,
                activar_experiencias: this.manager.activar_experiencias,
                ocultar_experiencias: this.manager.ocultar_experiencias,
                ocultar_futbol_base: this.manager.ocultar_futbol_base,
                activar_pack: this.manager.activar_pack,
                ocultar_pack: this.manager.ocultar_pack,
                ocultar_renovar_abono: this.manager.ocultar_renovar_abono,
                renovacion_futbol_base: this.manager.renovacion_futbol_base,
                ocultar_renovacion_futbol_base: this.manager.ocultar_renovacion_futbol_base,
                imagen_abono_cabecera: this.manager.imagen_abono_cabecera,
                imagen_abono_publicidad: this.manager.imagen_abono_publicidad,
                imagen_abono_patrocinadores: this.manager.imagen_abono_patrocinadores,
                condiciones_bases_plazos: this.manager.condiciones_bases_plazos,
                imagen_base_patrocinadores: this.manager.imagen_base_patrocinadores,
                imagen_base_cabecera: this.manager.imagen_base_cabecera,
                imagen_base_publicidad: this.manager.imagen_base_publicidad,
                condiciones_abonos_plazos: this.manager.condiciones_abonos_plazos,
                documentacion_obligatoria_bases: this.manager.documentacion_obligatoria_bases,
                renovar_abono_solo_con_dni: this.manager.renovar_abono_solo_con_dni,
                comprobar_dni: this.manager.comprobar_dni,
                comprobacion_butacas_abonos: this.manager.comprobacion_butacas_abonos,
                activar_acreditaciones: this.manager.activar_acreditaciones,
                ocultar_acreditaciones: this.manager.ocultar_acreditaciones,
            };

            this.$store.dispatch(this.config.getVuexAlias('back.lista.editar.manager'), params).then(res => {
                this.$toast.success(res.data.message);
            });
        }
    },
    components: {
        Opciones, ImagenesWeb, ImagenesEntrada, Patrocinadores, MainContentTabs, TipoEntrada, Bases, ApiCrm, Abonos, ImagenesBase, MetodosPago
    }
}
</script>